import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AppBar,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Radio,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import React, { FC, useEffect, useRef, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import loaderGif from '../common/no_bg_loader.gif';
import request from 'src/utils/request';
import { useReactToPrint } from 'react-to-print';
import CustomerDetails from '../Rfq/rfqViewBox/CustomerDetails';
import ProductCategoryDetails from '../Rfq/rfqViewBoxV2/ProductCategoryDetails';
import DynamicForm from '../Offers/RfqView/DynamicFormQc';


import CloseAndCoverage from '../Rfq/rfqViewBoxV2/CloseAndCoverage';
import Claims from '../Rfq/rfqViewBoxV2/Claims';
import Attachments from '../Rfq/rfqViewBoxV2/Attachments';
import NoDataAvailable from '../common/NoDataAvailable';
import parse from 'html-react-parser';
import moment from 'moment';
import PrintIcon from '@mui/icons-material/Print';
import RiskDescription from '../Rfq/rfqViewBoxV2/RiskDescription';
import Document from '../common/document.jpg';
import Scrollbars from 'react-custom-scrollbars-2';
import DifferentialBrokerage from '../Offers/OfferList/DifferentialBrokerage';
import FileImage from '../common/document.jpg';
import PlacementSlipCustomerDetails from '../PlacementSlips/PlacementSlipCustomerDetails';
import PlacementSlipRiskDescription from '../PlacementSlips/PlacementSlipRiskDescription';
import SumInsured from '../Offers/RfqView/SumInsured';
import SecondDynamicForm from '../Offers/RfqView/SecondDynamicFormQc';
import ThirdDynamicForm from '../Offers/RfqView/ThirdDynamicFormQc';
import PlacementDetailCoInsurerSection from '../PlacementSlips/PlacementDetailCoInsurerSection';
import PlacementDetailInstallmentSection from './PlacementDetailInstallmentSection';
import PlacementDetailSection from '../PlacementSlips/PlacementDetailSection';
import PolicyQcInputFields from '../policies/PolicyQcInputFields';
import OfferClauseAndCoverage from './OfferClauseAndCoverage';
import InsurancePremiumDetails from '../policies/InsurancePremiumDetails';
import PolicyCompareQcRemarks from './PolicyCompareQcRemarks';
// import RfqJourney from '../Rfq/rfqViewBoxV2/RfqJourney';

type PolicyDetailsViewProps = {
  detailsView: boolean;
  handleDetailsClose: Function;
  placementSlipDetails: any;
  policyDetail?: any;
  qcRemarkOfEachSections?: object;
  setQcRemarkOfEachSections?: Function;
  checkAllModuleIsVerified?: Function;
};

const PolicyCompareDetailView: FC<PolicyDetailsViewProps> = ({
  detailsView,
  handleDetailsClose,
  placementSlipDetails,
  policyDetail,
  qcRemarkOfEachSections,
  setQcRemarkOfEachSections,
  checkAllModuleIsVerified
}) => {

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const [loader, setLoader] = useState(false);
  const [rfqDetails, setRfqDetails] = useState([]);
  const [offerLoading, setOfferLoading] = useState(false);
  const [hasAttachmentData, setHasAttachmentData] = useState(true);
  const [hasClaimData, setHasClaimData] = useState(true);
  const [remarksRefreshKey, setRemarksRefreshKey] = useState(0);

  console.log("rfqDetails", rfqDetails);

  useEffect(() => {
    if (!hasClaimData) {
      qcRemarkOfEachSections["claim_details"] = {
        ...qcRemarkOfEachSections["claim_details"],
        isActive: false,
      };
    }
  }, [hasClaimData])

  useEffect(() => {
    if (!hasAttachmentData) {
      qcRemarkOfEachSections["attachment_details"] = {
        ...qcRemarkOfEachSections["attachment_details"],
        isActive: false,
      };
    }
  }, [hasAttachmentData])



  // const [rfqOfferData, setRFQOfferData] = useState<any[]>([]);
  const [accordionStatus, setAccordionStatus] = useState<{
    flag: boolean;
    accordion1: boolean;
    accordion2: boolean;
    accordion3: boolean;
    accordion4: boolean;
  }>({
    flag: false,
    accordion1: false,
    accordion2: false,
    accordion3: false,
    accordion4: false
  });
  const [customerSelectedOfferData, setCustomerSelectedOfferData] = useState<
    any[]
  >([]);
  const [clauseAndCoverageData, setClauseAndCoverageData] = useState([]);
  const [clauseNoDataDetails, setClauseNoDataDetails] = useState<any>([]);
  const [coverageNoDataDetails, setCoverageNoDataDetails] = useState<any>([]);
  const [insuranceCompanyName, setInsuranceCompanyName] = useState(null);
  const [placementSlipLoader, setPlacementSlipLoader] = useState(false);
  const [placementSlipData, setPlacementSlipData] = useState([]);
  const [installmentDetails, setInstallmentDetails] = useState([]);
  const [insuranceCompanyDetails, setInsuranceCompanyDetails] = useState([]);
  const [differentialBrokerageDetails, setDifferentialBrokerageDetails] =
    useState([]);

  const hasPlacementSlipAttachments = placementSlipData?.[0]?.documents?.length > 0;

  useEffect(() => {
    if (hasPlacementSlipAttachments && qcRemarkOfEachSections["placement_details"]?.[0]?.["placement_Slip_Attachments"]) {
      qcRemarkOfEachSections["placement_details"][0]["placement_Slip_Attachments"] = {
        ...qcRemarkOfEachSections["placement_details"]?.[0]?.["placement_Slip_Attachments"],
        isActive: hasPlacementSlipAttachments,
      };
    }


  }, [hasPlacementSlipAttachments]);

  let serialNumberClause = 1;
  let serialNumberCoverage = 1;

  useEffect(() => {
    if (placementSlipDetails) {
      fetchRfqDetails(policyDetail.insurancePolicy?.rfqId);
      getRFQOfferLists(policyDetail.insurancePolicy?.rfqId);
      getPlacementSlips(policyDetail.insurancePolicy?.placementId);
    }
  }, [placementSlipDetails]);
  const fetchRfqDetails = (rfqId) => {
    setLoader(true);
    request({
      url: 'rfq/getRfqDetails',
      method: 'post',
      data: {
        rfqId: rfqId
      }
    }).then(
      (response: any) => {
        setRfqDetails(response.rfq);
        setLoader(false);
      },
      (error) => {
        console.log(error);
        setLoader(false);
      }
    );
  };

  const getRFQOfferLists = (rfqId) => {
    setOfferLoading(true);
    request({
      url: 'rfqOffers/getRfqOffersList',
      method: 'post',
      data: {
        rfqId: rfqId
      }
    }).then(
      (response: any) => {
        // setRFQOfferData(
        // eslint-disable-next-line array-callback-return
        response?.map((item, index) => {
          if (item.customerOffer?.[0]?.selected) {
            setCustomerSelectedOfferData(item);
            setClauseAndCoverageData(item.policyClauseJSON);
            setInsuranceCompanyName(item.inscompany.name);
          }
        });
        // );

        setOfferLoading(false);
      },
      (error) => {
        setOfferLoading(false);
        console.log(error);
      }
    );
  };

  const getPlacementSlips = (placementSlipId) => {
    setPlacementSlipLoader(true);
    request({
      url: 'placement/getPlacementSlipById',
      method: 'post',
      data: {
        placementSlipId: placementSlipId
      }
    }).then(
      (response) => {
        setPlacementSlipData(response['rows']);
        setInstallmentDetails(response['rows'][0].installmentDetails);
        setInsuranceCompanyDetails(response['rows'][0].coInsuranceCompanyList);
        setDifferentialBrokerageDetails(
          response['rows'][0]?.differentialBrokerageDetails
        );
        setPlacementSlipLoader(false);
      },
      (error) => {
        console.log(error);
        setPlacementSlipLoader(false);
      }
    );
  };

  useEffect(() => {
    if (clauseAndCoverageData) {
      let clauseNoData = [];
      let coverageNoData = [];
      clauseAndCoverageData.forEach((data) => {
        if (data.insurenceClause.type === 'clause') {
          clauseNoData.push(data);
        }

        if (data.insurenceClause.type === 'coverage') {
          coverageNoData.push(data);
        }
        setClauseNoDataDetails(clauseNoData);
        setCoverageNoDataDetails(coverageNoData);
      });
    }
  }, [clauseAndCoverageData]);

  const componentRef = useRef();
  const printForm = useReactToPrint({
    content: () => componentRef.current
  });



  return (
    <>
      <div ref={componentRef}>
        <Card sx={{ margin: '1%' }}>
          <CardContent>
            <Stack direction="row" justifyContent="space-between" spacing={2}>
              {loader || placementSlipLoader ? (
                <Stack
                  sx={{
                    color: 'grey.500',
                    margin: '15% 47.5% 15% 47.5%'
                  }}
                  spacing={2}
                  direction="row"
                  justifyContent="center"
                  mt={5}
                >
                  <img
                    alt="loader"
                    src={loaderGif}
                    className="loader"
                    width={100}
                    height={100}
                  />
                </Stack>
              ) : (
                <>
                  <Stack
                    direction="row"
                    divider={<Divider orientation="vertical" flexItem />}
                    spacing={2}
                  >
                    <Chip label={rfqDetails?.['title']} variant="outlined" />
                    <Chip
                      label={rfqDetails?.['productCategory']?.name}
                      variant="outlined"
                    />
                    <Chip
                      label={rfqDetails?.['policyProduct']?.name}
                      variant="outlined"
                    />
                    {placementSlipData?.[0]?.['placementId'] ? (
                      <Chip
                        label={placementSlipData?.[0]?.['placementId']}
                        variant="outlined"
                      />
                    ) : null}
                  </Stack>
                </>
              )}
            </Stack>
          </CardContent>
        </Card>
        {loader || placementSlipLoader ? null : (
          <>
            <div >

              <div>
                <Table className="rfqView">
                  <PlacementSlipCustomerDetails
                    rfqDetails={rfqDetails}
                    placementSlipData={placementSlipData}
                    type={'qc'}
                    policyDetail={policyDetail}
                  />
                </Table>
                <div
                  style={{
                    opacity:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.insured_details?.status === 'approve'
                        ? 0.5
                        : 1,
                    pointerEvents:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.insured_details?.status === 'approve'
                        ? 'none'
                        : 'auto',
                    marginBottom: '10px'
                  }}
                >
                  <PolicyCompareQcRemarks
                    modouleDetail={policyDetail}
                    qcRemarkOfEachSections={qcRemarkOfEachSections}
                    section_key={'insured_details'}
                    block_key={''}
                    checkAllModuleIsVerified={
                      checkAllModuleIsVerified
                    }
                    setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                  />
                </div>


              </div>
              {rfqDetails?.['riskDescription'] && <div
              >
                <Table className="rfqView">
                  <PlacementSlipRiskDescription
                    rfqDetails={rfqDetails}
                    placementSlipData={placementSlipData}
                    rfqId={rfqDetails['id']}
                    type={'qc'}
                    policyDetail={policyDetail}
                  />
                </Table>
                <div
                  style={{
                    opacity:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.risk_description_details?.status === 'approve'
                        ? 0.5
                        : 1,
                    pointerEvents:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.risk_description_details?.status === 'approve'
                        ? 'none'
                        : 'auto',
                    marginBottom: '10px'
                  }}

                >
                  <PolicyCompareQcRemarks
                    modouleDetail={policyDetail}
                    qcRemarkOfEachSections={qcRemarkOfEachSections}
                    section_key={'risk_description_details'}
                    block_key={''}
                    checkAllModuleIsVerified={
                      checkAllModuleIsVerified
                    }
                    setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                  />
                </div>
              </div>}

              <div>
                <div style={{
                  marginTop: '10px', background: 'rgb(9, 84, 174)',
                  paddingTop: '4px', paddingBottom: '4px', textAlign: 'center', color: 'rgb(255, 255, 255)'
                }}>
                  Policy details
                </div>
                <Table style={{
                  opacity:
                    (
                      policyDetail?.parentqcData ||
                      policyDetail?.insurancePolicy?.qcData
                    )?.policy_details?.status === 'approve'
                      ? 0.5
                      : 1,
                  pointerEvents:
                    (
                      policyDetail?.parentqcData ||
                      policyDetail?.insurancePolicy?.qcData
                    )?.policy_details?.status === 'approve'
                      ? 'none'
                      : 'auto',
                }}>
                  <TableRow>
                    <TableCell style={{ width: '50%', paddingTop: '8px', paddingBottom: '8px' }}>policy no</TableCell>
                    <TableCell style={{ width: '50%', paddingTop: '8px', paddingBottom: '8px' }}>{policyDetail?.policyNumber}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ width: '50%', paddingTop: '8px', paddingBottom: '8px' }}>
                      Policy Period
                    </TableCell>
                    <TableCell style={{ width: '50%', paddingTop: '8px', paddingBottom: '8px' }}>
                      <Box display="flex" gap="2vw">
                        <span>
                          From:{' '}
                          {placementSlipData?.[0]?.policyStartDate
                            ? moment(placementSlipData[0].policyStartDate).format(
                              'DD-MM-YYYY'
                            )
                            : 'N/A'}
                        </span>
                        <span>
                          To:{' '}
                          {placementSlipData?.[0]?.policyEndDate
                            ? moment(placementSlipData[0].policyEndDate).format(
                              'DD-MM-YYYY'
                            )
                            : 'N/A'}
                        </span>
                      </Box>
                    </TableCell>
                  </TableRow>

                </Table>
                <div
                  style={{
                    opacity:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.policy_details?.status === 'approve'
                        ? 0.5
                        : 1,
                    pointerEvents:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.policy_details?.status === 'approve'
                        ? 'none'
                        : 'auto',
                    marginBottom: '10px'
                  }}
                >
                  <PolicyCompareQcRemarks
                    modouleDetail={policyDetail}
                    qcRemarkOfEachSections={qcRemarkOfEachSections}
                    section_key={'policy_details'}
                    block_key={''}
                    checkAllModuleIsVerified={
                      checkAllModuleIsVerified
                    }
                    setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                  />
                </div>
              </div>


              {rfqDetails['rfqTemplate']?.dynamicForm ? (
                <div>
                  <div className="rfqView">
                    <DynamicForm rfqDetails={rfqDetails} type={'qc'} policyDetail={policyDetail} />
                  </div>
                  <div
                    style={{
                      opacity: (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.dynamic_form_detail?.status === 'approve'
                        ? 0.5
                        : 1,
                      pointerEvents:
                        (
                          policyDetail?.parentqcData ||
                          policyDetail?.insurancePolicy?.qcData
                        )?.dynamic_form_detail?.status === 'approve'
                          ? 'none'
                          : 'auto',
                      marginBottom: '10px'
                    }}
                  >
                    <PolicyCompareQcRemarks
                      modouleDetail={policyDetail}
                      qcRemarkOfEachSections={qcRemarkOfEachSections}
                      section_key={'dynamic_form_detail'}
                      block_key={''}
                      checkAllModuleIsVerified={
                        checkAllModuleIsVerified
                      }
                      setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                      sectionName={rfqDetails['dynamicFormData']?.[0]?.groupName ?? ''}
                    />
                  </div>
                </div>

              ) : null}

              {rfqDetails['rfqTemplate']?.sumInsuredSection &&
                rfqDetails['rfqTemplate']
                  ?.rfqTemplatesSumInsuredSections?.length > 0 ? (
                <div style={{ overflow: 'scroll' }}>
                  <Table className="rfqView">
                    <SumInsured
                      sumInsuredDatas={
                        rfqDetails['rfqSumInsuredSections']
                      }
                      rfqId={rfqDetails['id']}
                      showTotal={rfqDetails['showTotalSumInsured']}
                      usedfrom="offer"
                      customerId={
                        rfqDetails['retailCustomerId']
                          ? rfqDetails['retailCustomerId']
                          : rfqDetails['corporateCustomerId']
                      }
                      customerType={rfqDetails[
                        'customerType'
                      ]?.toLowerCase()}
                      rfqDetails={rfqDetails}
                      placementSlip={true}
                      type={'qc'}
                      policyDetail={policyDetail}
                      qcRemarkOfEachSections={qcRemarkOfEachSections}
                      checkAllModuleIsVerified={checkAllModuleIsVerified}
                      setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                      EndorsementCompareQcRemarks={PolicyCompareQcRemarks}
                    />
                  </Table>
                </div>
              ) : null}



              {rfqDetails['rfqTemplate']?.secondDynamicForm ? (
                <div>
                  <div className="rfqView">
                    <SecondDynamicForm rfqDetails={rfqDetails} type={'qc'} policyDetail={policyDetail} />
                  </div>
                  <div
                    style={{
                      opacity:
                        (
                          policyDetail?.parentqcData ||
                          policyDetail?.insurancePolicy?.qcData
                        )?.dynamic_form_2_detail?.status === 'approve'
                          ? 0.5
                          : 1,
                      pointerEvents:
                        (
                          policyDetail?.parentqcData ||
                          policyDetail?.insurancePolicy?.qcData
                        )?.dynamic_form_2_detail?.status === 'approve'
                          ? 'none'
                          : 'auto',
                      marginBottom: '10px'
                    }}
                  >
                    <PolicyCompareQcRemarks
                      modouleDetail={policyDetail}
                      qcRemarkOfEachSections={qcRemarkOfEachSections}
                      section_key={'dynamic_form_2_detail'}
                      block_key={''}
                      checkAllModuleIsVerified={
                        checkAllModuleIsVerified
                      }
                      setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                      sectionName={rfqDetails['secondDynamicFormData']?.[0]?.groupName ?? ''}
                    />
                  </div>
                </div>

              ) : null}

              {rfqDetails['rfqTemplate']?.thirdDynamicForm ? (
                <div>
                  <div className="rfqView">
                    <ThirdDynamicForm rfqDetails={rfqDetails} type={'qc'} policyDetail={policyDetail} />
                  </div>
                  <div
                    style={{
                      opacity: (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.dynamic_form_3_detail?.status === 'approve'
                        ? 0.5
                        : 1,
                      pointerEvents: (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.dynamic_form_3_detail?.status === 'approve'
                        ? 'none'
                        : 'auto',
                      marginBottom: '10px'
                    }}>
                    <PolicyCompareQcRemarks
                      modouleDetail={policyDetail}
                      qcRemarkOfEachSections={qcRemarkOfEachSections}
                      section_key={'dynamic_form_3_detail'}
                      block_key={''}
                      checkAllModuleIsVerified={
                        checkAllModuleIsVerified
                      }
                      setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                      sectionName={rfqDetails['thirdDynamicFormData']?.[0]?.groupName ?? ''}
                    />
                  </div>
                </div>

              ) : null}

              {hasClaimData ? (
                <div
                  style={{
                    opacity:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.claim_details?.status === 'approve'
                        ? 0.5
                        : 1,
                    pointerEvents:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.claim_details?.status === 'approve'
                        ? 'none'
                        : 'auto',
                  }}
                >
                  <div className="rfqView">
                    <Claims
                      rfqDetails={rfqDetails}
                      offerStatus={null}
                      onDataLoad={(claims) =>
                        setHasClaimData(claims.length > 0)
                      }
                    />

                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    <PolicyCompareQcRemarks
                      modouleDetail={policyDetail}
                      qcRemarkOfEachSections={qcRemarkOfEachSections}
                      section_key={'claim_details'}
                      block_key={''}
                      checkAllModuleIsVerified={
                        checkAllModuleIsVerified
                      }
                      setQcRemarkOfEachSections={setQcRemarkOfEachSections}

                    />
                  </div>
                </div>

              ) : null}



              {/* {placementSlipData?.[0]?.coInsuranceApplicable ===
                true ? (
                <div>
                  <Table>
                    <TableRow className="noBorder">
                      <TableCell
                        colSpan={2}
                        style={{
                          padding: 0,
                          border: 'none',
                          paddingTop: '0!important',
                          paddingBottom: '0!important'
                        }}
                      >
                        <PlacementDetailCoInsurerSection
                          insuranceCompanyDetails={insuranceCompanyDetails}
                        />
                      </TableCell>
                    </TableRow>
                  </Table>
                  <div style={{ marginBottom: '10px' }}>
                    <PolicyCompareQcRemarks
                      modouleDetail={policyDetail}
                      qcRemarkOfEachSections={qcRemarkOfEachSections}
                      section_key={'placement_details'}
                      block_key={''}
                      checkAllModuleIsVerified={
                        checkAllModuleIsVerified
                      }
                      setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                    />
                  </div>
                </div>

              ) : null} */}


              <div>
                <OfferClauseAndCoverage
                  // customerSelectedOfferData={customerSelectedOfferData}
                  coverageNoDataDetails={coverageNoDataDetails}
                  clauseAndCoverageData={clauseAndCoverageData}
                  serialNumberCoverage={serialNumberCoverage}
                  clauseNoDataDetails={clauseNoDataDetails}
                  serialNumberClause={serialNumberClause}
                  modouleDetail={policyDetail}
                  qcRemarkOfEachSections={qcRemarkOfEachSections}
                  setRemarksRefreshKey={setRemarksRefreshKey}
                  checkAllModuleIsVerified={checkAllModuleIsVerified}
                  setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                  policyDetail={policyDetail}
                />

              </div>
              <div>
                <InsurancePremiumDetails
                  customerSelectedOfferData={
                    customerSelectedOfferData
                  }
                  placementSlipData={placementSlipData}
                  policyDetail={policyDetail}
                />
                <div
                  style={{
                    opacity:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.insurance_premium_details?.status === 'approve'
                        ? 0.5
                        : 1,
                    pointerEvents:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.insurance_premium_details?.status === 'approve'
                        ? 'none'
                        : 'auto',
                    marginBottom: '10px'
                  }}
                >
                  <PolicyCompareQcRemarks
                    modouleDetail={policyDetail}
                    qcRemarkOfEachSections={qcRemarkOfEachSections}
                    section_key={'insurance_premium_details'}
                    block_key={''}
                    checkAllModuleIsVerified={
                      checkAllModuleIsVerified
                    }
                    setQcRemarkOfEachSections={setQcRemarkOfEachSections}

                  />
                </div>

              </div>
              {placementSlipData[0]?.coInsuranceApplicable && <div

              >
                <PlacementDetailSection
                  placementSlipData={placementSlipData}
                  installmentDetails={installmentDetails}
                  type='qc'
                  policyDetail={policyDetail}
                />
                <div
                  style={{
                    opacity:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.co_insurance_details?.status === 'approve'
                        ? 0.5
                        : 1,
                    pointerEvents:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.co_insurance_details?.status === 'approve'
                        ? 'none'
                        : 'auto',
                    marginBottom: '10px'
                  }}
                >
                  <PolicyCompareQcRemarks
                    modouleDetail={policyDetail}
                    qcRemarkOfEachSections={qcRemarkOfEachSections}
                    section_key={'co_insurance_details'}
                    block_key={''}
                    checkAllModuleIsVerified={
                      checkAllModuleIsVerified
                    }
                    setQcRemarkOfEachSections={setQcRemarkOfEachSections}

                  />
                </div>

              </div>
              }





              <div>
                <Table>
                  <TableRow className="noBorder">
                    <TableCell
                      colSpan={2}
                      style={{
                        padding: 0,
                        border: 'none',
                        paddingTop: '0!important',
                        paddingBottom: '0!important'
                      }}
                    >
                      <PlacementDetailInstallmentSection
                        installmentDetails={installmentDetails}
                        placementSlipData={placementSlipData?.[0]}
                        type={'qc'}
                        policyDetail={policyDetail}
                        qcRemarkOfEachSections={qcRemarkOfEachSections}
                        checkAllModuleIsVerified={checkAllModuleIsVerified}
                        setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                      />
                    </TableCell>
                  </TableRow>
                </Table>

              </div>
              <div>
                <div style={{ marginTop: '10px', background: 'rgb(9, 84, 174)', textAlign: 'center', color: 'rgb(255, 255, 255)' }}>
                  Deductible Applicable
                </div>
                <div
                  style={{
                    opacity:
                      ['approve', 'NA'].includes(
                        (
                          policyDetail?.parentqcData ||
                          policyDetail?.insurancePolicy?.qcData
                        )?.suggestedDeductible?.status
                      )
                        ? 0.5
                        : 1,
                    pointerEvents:
                      ['approve', 'NA'].includes(
                        (
                          policyDetail?.parentqcData ||
                          policyDetail?.insurancePolicy?.qcData
                        )?.suggestedDeductible?.status
                      )
                        ? 'none'
                        : 'auto',
                    marginBottom: '10px',
                    marginTop: '10px'
                  }}
                >
                  <PolicyQcInputFields sectionName="suggestedDeductible"
                    label="Deductible Applicable"
                    qcRemarkOfEachSections={qcRemarkOfEachSections}
                    setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                    modouleDetail={policyDetail}
                    checkAllModuleIsVerified={
                      checkAllModuleIsVerified
                    }
                    default={!qcRemarkOfEachSections?.['suggestedDeductible']?.value ? policyDetail?.suggestedDeductible : ''}
                  />

                  <PolicyCompareQcRemarks
                    modouleDetail={policyDetail}
                    qcRemarkOfEachSections={qcRemarkOfEachSections}
                    section_key={'suggestedDeductible'}
                    block_key={''}
                    checkAllModuleIsVerified={
                      checkAllModuleIsVerified
                    }
                    setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                  />
                </div>

              </div>
              <div>
                <div style={{ marginTop: '10px', background: 'rgb(9, 84, 174)', textAlign: 'center', color: 'rgb(255, 255, 255)' }}>
                  Warranties / exclusions to be deleted
                </div>
                <div
                  style={{
                    opacity:
                      ['approve', 'NA'].includes(
                        (
                          policyDetail?.parentqcData ||
                          policyDetail?.insurancePolicy?.qcData
                        )?.warranties_exclusions?.status
                      )
                        ? 0.5
                        : 1,
                    pointerEvents:
                      ['approve', 'NA'].includes(
                        (
                          policyDetail?.parentqcData ||
                          policyDetail?.insurancePolicy?.qcData
                        )?.warranties_exclusions?.status
                      )
                        ? 'none'
                        : 'auto',
                    marginBottom: '10px',
                    marginTop: '10px'
                  }}
                >
                  <PolicyQcInputFields sectionName="warranties_exclusions"
                    label="Warranties / exclusions to be deleted"
                    qcRemarkOfEachSections={qcRemarkOfEachSections}
                    setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                    modouleDetail={policyDetail}
                    checkAllModuleIsVerified={
                      checkAllModuleIsVerified
                    }
                  />

                  <PolicyCompareQcRemarks
                    modouleDetail={policyDetail}
                    qcRemarkOfEachSections={qcRemarkOfEachSections}
                    section_key={'warranties_exclusions'}
                    block_key={''}
                    checkAllModuleIsVerified={
                      checkAllModuleIsVerified
                    }
                    setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                  />
                </div>

              </div>
              <div>
                <div style={{ marginTop: '10px', background: 'rgb(9, 84, 174)', textAlign: 'center', color: 'rgb(255, 255, 255)' }}>
                  Policy seal and sign
                </div>
                <div style={{
                  opacity:
                    (
                      policyDetail?.parentqcData ||
                      policyDetail?.insurancePolicy?.qcData
                    )?.policy_seal_and_sign?.status === 'approve'
                      ? 0.5
                      : 1,
                  pointerEvents:
                    (
                      policyDetail?.parentqcData ||
                      policyDetail?.insurancePolicy?.qcData
                    )?.policy_seal_and_sign?.status === 'approve'
                      ? 'none'
                      : 'auto',
                  marginBottom: '10px', marginTop: '10px'
                }}>
                  <PolicyQcInputFields sectionName="policy_seal_and_sign"
                    label="Policy seal and sign"
                    qcRemarkOfEachSections={qcRemarkOfEachSections}
                    setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                    modouleDetail={policyDetail}
                    checkAllModuleIsVerified={
                      checkAllModuleIsVerified
                    }

                  />

                  <PolicyCompareQcRemarks
                    modouleDetail={policyDetail}
                    qcRemarkOfEachSections={qcRemarkOfEachSections}
                    section_key={'policy_seal_and_sign'}
                    block_key={''}
                    checkAllModuleIsVerified={
                      checkAllModuleIsVerified
                    }
                    setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                  />
                </div>

              </div>





            </div>

          </>

        )}
      </div>
    </>
  );
};

export default PolicyCompareDetailView;
